<template>
    <div>
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Academic Daily Log Book</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3" md="3">
                        <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" @change="getaystddivonrole()" />
                    </v-col>

                    <v-col cols="12" sm="3" md="3" v-if="standard_list != ''">
                        <p><v-icon color="error">*</v-icon><b>Standard</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
                            item-text="std" item-value="std_id" label="standard" outlined persistent-hint
                            hint="Please Select Standard" />
                    </v-col>

                    <v-col cols="12" sm="3" md="3" v-if="division_list != ''">
                        <p><v-icon color="error">*</v-icon><b> Division</b></p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="division" :items="division_list"
                            item-text="div_name" item-value="div_id" label="Division" outlined persistent-hint
                            hint="Please Select Division" />
                    </v-col>

                </v-row>


            </v-card>

        </v-container>




    </div>

</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        overlay: false,
        criteria: "",
        ay_list: [],
        ay: "",
        apprisal_level_list: [],
        self_appriasal_parameter_list: [],
        standard: null,
        division: null,
        division_list: [],
        standard_list: [],
        self_appriasal_sub_parameter_list: [],
        selfAppraisalSubParameter: null,
        dialog_edit: false,
        dialog_view: false,
        self_apprisal_level_linking_list: [],

        filters: {
            academicyear: [],
            standard: [],
            selfappraisalsubParameter: [],
            appraisallevel: [],
        },

    }),
    methods: {
        getaystddivonrole() {
            const data = {
                ay: this.ay,
            };
            this.overlay = true;
            axios
                .post("/App/get_ay_std_div_on_role_copy", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.standard_list =
                            res.data.data;
                        this.division_list = this.standard_list.flatMap(standard => standard.div_list);

                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                })
                .catch((error) => {
                    this.onerror(error);

                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        onLoad() {
            axios
                .post("App/getAcademicYear")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.ay_list = res.data.ay_list;

                        this.overlay = false;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    },
    mounted() {
        this.onLoad();
    },
    watch: {},
    // computed: {
    //     bookList1() {
    //         return this.self_apprisal_level_linking_list.filter((d) => {
    //             return Object.keys(this.filters).every((f) => {
    //                 return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
    //             });
    //         });
    //     },
    // },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.dialogview {
    overflow: hidden;
}

.box1 {
    width: 100%;
    overflow: hidden;
    border: 2px solid #8360c3;
}

.viewdesc {
    cursor: pointer;
}
</style>
